import { FC } from 'react';
import { Container, Heading, Text, VStack } from '@chakra-ui/layout';
import CrucibleSearch from './CrucibleSearch';

type Props = {
  message: React.ReactElement;
};

const SearchError: FC<Props> = ({ message }) => {
  return (
    <Container>
      <VStack spacing={2}>
        <Heading>Not a Crucible address</Heading>
        <Text
          pb={4}
          textAlign='center'
          wordBreak='break-word'
          color='whiteAlpha.700'
        >
          {message}
        </Text>
        <CrucibleSearch />
      </VStack>
    </Container>
  );
};

export default SearchError;
